
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/twitter-success",
      function () {
        return require("private-next-pages/twitter-success.js");
      }
    ]);
  